module.exports = __webpack_public_path__ + "static/media/SM-ST-4.9f531050.mp3";